/* eslint-disable */
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import {
  fetchAssetCategories,
  fetchDeviceType,
  fetchDeviceModel,
  fetchDeviceInfo,
  updateDevice,
  downloadImage,
  imageUpload,
  addDeviceIndicator,
  addDeviceParameter
} from '../../redux/actionCreators'
import { type AssetCategoriesState } from '../../redux/assetCategoriesSlice'
import { type DeviceTypeState } from '../../redux/deviceTypeSlice'
import { type DeviceModelState } from '../../redux/deviceModelSlice'
import { type DeviceInfoState } from '../../redux/deviceInfoSlice'
import { type DownloadImageState } from '../../redux/downloadImageSlice'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { type RootState } from '../../../../store'
import { type OperationPermissionState } from '../../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../../dashboard/redux/actionCreator'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import SelectDeviceType from '../../../../assets/SelectDeviceType.png'
import AddParameters from '../../../../assets/AddParameters.png'
import DeviceInformation from './DeviceInformation'
import EditDeviceParameters from './EditDeviceParameters'
import AddDeviceDummy from '../../../../assets/AddDeviceDummy/image.png'
import { type UpdateDevicePutRequest } from '../../services/updateDeviceService'
import { type UpdateDeviceState } from '../../redux/updateDeviceSlice'
import Modal from '../../../../components/Modal'
import { CircularProgress } from '@mui/material'
import CustomToast from '../ToastComponent'
import { type ImageUploadState } from '../../redux/imageUploadSlice'
import { type ImageUploadPostRequest } from '../../services/imageUploadService'
import { isValidDevicePort, isValidDeviceData, isValidLatLong, isValidSlaveAddress } from '../../../../utils/validator'
import { reset } from '../../redux/updateDeviceSlice'
import { ImageUploadReset } from '../../redux/imageUploadSlice'
import { modbusParamsReset } from '../../redux/modbusParamsSlice'
import { useDispatch } from 'react-redux'
import { APIConfiguration } from '../../../../utils/apiConfiguration'
import AuthError from "../../../../components/ErrorComponents/AuthError"
import { type DeviceIndicatorState } from '../../redux/addDeviceIndicatorSlice'
import { type DeviceParameterState } from '../../redux/addDeviceParameterSlice'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import { indicatorReset } from '../../redux/indicatorSlice'
import useRefreshHamburgNotifier from '../../../../customHooks/useRefreshHamburgNotifier'
import ConfigureDevice from '../configureDevice'

const httpStatus = APIConfiguration
const MAX_LENGTH = 100
const AddDeviceStrings = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent
const DashboardStrings = LanguageStrings().Dashboard

interface LabelValue {
  label: string
  value: string
}

const EditDevice = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const stateLocation = useLocation()
  // const [parentAssetId, setParentAssetId] = React.useState<any>('')
  const { deviceIdParam } = useParams() as { deviceIdParam: string };
  const [isDeviceDetailsEnabled, setIsDeviceDetailsEnabled] = React.useState(true)
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )
  const [categoryTypeId, setCategoryTypeId] = React.useState('')
  const [assetType, setAssetType] = React.useState<any>(null)
  const [assetModel, setAssetModel] = React.useState<any>(null)
  const [deviceId, setDeviceId] = React.useState<any>('')
  const [deviceName, setDeviceName] = React.useState<any>('')
  const [deviceNameErrorInit, setDeviceNameErrorInit] = React.useState(false)
  const [serialNumber, setSerialNumber] = React.useState<any>('')
  const [gateway, setGateway] = React.useState<any>('')
  const [serialNumberErrorInit, setSerialNumberErrorInit] = React.useState(false)
  const [applicationType, setApplicationType] = React.useState<any>('')
  const [applicationTypeErrorInit, setApplicationTypeErrorInit] = React.useState(false)
  const [location, setLocation] = React.useState<any>('')
  const [locationErrorInit, setLocationErrorInit] = React.useState(false)
  const [slaveAddress, setSlaveAddress] = React.useState<any>('')
  const [slaveAddressErrorInit, setSlaveAddressErrorInit] = React.useState(false)
  const [previewImage, setPreviewImage] = React.useState<any>(AddDeviceDummy)
  const [deviceIdAfterUpdate, setDeviceIdAfterUpdate] = React.useState('')
  const [deviceImage, setDeviceImage] = React.useState<any>()
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [isStdError, setIsStdError] = React.useState(false)
  const [isCustomError, setIsCustomError] = React.useState(false)
  const [isModbusError, setIsModbusError] = React.useState(false)
  const [indicators, setIndicators] = React.useState<any>([])
  const [parameters, setParameters] = React.useState<any>([])
  const [isDeviceCreateInProgress, setIsDeviceCreateInProgress] = React.useState<boolean>(false)
  const [portNumber, setPortNumber] = React.useState<any>('')
  const [portNumberErrorInit, setPortNumberErrorInit] = React.useState(false)
  const { refreshHamburgAction } = useRefreshHamburgNotifier()

  const auth = useAuth()
  const thermalCategory = 'Thermal'
  interface StateLocation {
    parentSiteId: string
    deviceAssetId: string
    parentAssetId: string
    isTcpProtocol: boolean
  }
  const navigateState = stateLocation.state as StateLocation | null
  /* istanbul ignore next */
  const parentSiteId = (navigateState != null) ? navigateState.parentSiteId : ''
  const deviceAssetId = (navigateState != null) ? navigateState.deviceAssetId : ''
  const parentAssetId = (navigateState != null) ? navigateState.parentAssetId : ''
  const isTcpProtocol = (navigateState != null) ? navigateState.isTcpProtocol : false

  React.useEffect(() => {
    (parentSiteId === '' || parentSiteId === undefined || parentSiteId === null) && navigate('/site-list')
  }, [parentSiteId])

  React.useEffect(() => {
    return () => {
      setIsDeviceDetailsEnabled(true)
      setDeviceIdAfterUpdate('')
      dispatch(ImageUploadReset())
      dispatch(indicatorReset())
      dispatch(modbusParamsReset())
      dispatch(reset())
    };
  }, []);

  React.useEffect(() => {
    setIsDeviceDetailsEnabled(true)
    // istanbul ignore else
    if (!operationPermissions.updated) {
      props?.getOperationPermissions(auth.user?.profile.sub as string)
    }
    props?.fetchAssetCategories()
    props?.fetchDeviceInfo(deviceIdParam)
    props?.downloadImage(deviceIdParam, 'fdd42da4-4a13-4f57-9e1a-208d95c7f212', 'en_US')
  }, [])

  React.useEffect(() => {
    setAssetType({
      label: props?.deviceInfo?.deviceInfo?.device_type === 'Thermal-Controller-7800' ? '7800' : props?.deviceInfo?.deviceInfo?.device_type,
      value: props?.deviceInfo?.deviceInfo?.device_type_id,
    })
    /* istanbul ignore next */
    if (props?.deviceInfo?.deviceInfo?.device_type_id !== '') {
      props?.fetchDeviceModel(`${props?.deviceInfo?.deviceInfo?.device_type_id}`)
    }
  }, [props?.deviceInfo?.deviceInfo?.device_type_id]);

  React.useEffect(() => {
    setAssetModel({
      label: props?.deviceInfo?.deviceInfo?.device_model_name,
      value: props?.deviceInfo?.deviceInfo?.device_model_id,
    })
  }, [props?.deviceInfo?.deviceInfo?.device_model_id]);

  /* istanbul ignore next */
  React.useEffect(() => {
    setIsDeviceCreateInProgress(false)
    if (props?.downloadImageState?.downloadImage?.binaryData !== '') {
      setPreviewImage(props?.downloadImageState?.downloadImage?.binaryData)
      // setDeviceImage(props?.downloadImageState?.downloadImage?.binaryData)
    }
  }, [props?.downloadImageState?.downloadImage?.binaryData])

  React.useEffect(() => {
    // setParentAssetId(props?.deviceInfo?.deviceInfo?.parent_asset_id)
    setDeviceId(props?.deviceInfo?.deviceInfo?.id)
    setDeviceName(props?.deviceInfo?.deviceInfo?.name)
    setSerialNumber(props?.deviceInfo?.deviceInfo?.serial_number)
    setApplicationType(props?.deviceInfo?.deviceInfo?.application_type)
    setGateway('')
    /* istanbul ignore next */
    const latlong = (props?.deviceInfo?.deviceInfo?.latitude !== null && props?.deviceInfo?.deviceInfo?.longitude !== null) ? `${props?.deviceInfo?.deviceInfo?.latitude},${props?.deviceInfo?.deviceInfo?.longitude}` : ''
    setLocation(latlong)
    setSlaveAddress(props?.deviceInfo?.deviceInfo?.slave_id)
    setPortNumber(props?.deviceInfo?.deviceInfo?.port ?? '')
  }, [props?.deviceInfo?.deviceInfo?.name]);

  React.useEffect(() => {
    if (props?.updateDeviceState?.data !== undefined && props?.updateDeviceState?.isLoading === false && props?.updateDeviceState?.error === undefined) {
      setDeviceIdAfterUpdate(props?.updateDeviceState?.data?.asset_id ??'')
      refreshHamburgAction('Device', 'Update')
      if (deviceImage) {
        /* istanbul ignore next */
        props?.imageUpload({
          assetId: props?.updateDeviceState?.data?.asset_id ?? '',
          assetTypeId: assetType?.value,
          locale: 'en_US',
          file: deviceImage
        })
      } else {
        setIsDeviceDetailsEnabled(false)
      }
      handleUpdateDeviceWithFailure()
    }
  }, [props?.updateDeviceState])

  React.useEffect(() => {
    if (props?.imageUploadState.isLoading === false && props?.imageUploadState?.httpStatus === 201) {
      /* istanbul ignore next */
      setIsDeviceDetailsEnabled(false)
    }
    else {
      handleImageUploadWithFailure()
    }
  }, [props?.imageUploadState])

  React.useEffect(() => {
    if (props?.assetCategories?.assetCategories != null && props?.assetCategories.assetCategories?.length > 0) {
      const thermalCat = props?.assetCategories.assetCategories.find((cat: any) => cat.category_type_name === thermalCategory)
      if (thermalCat != null) {
        setCategoryTypeId(thermalCat.category_type_id)
        props?.fetchDeviceType(thermalCat.category_type_id)
      }
    }
    else {
      handleFetchCategoryWithFailure()
    }
  }, [props?.assetCategories])

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault()
  }

  const handeleCancelClick = (): void => {
    navigate(`/device-list/${parentAssetId}`, { state: { parentSiteId: parentSiteId, deviceAssetId: deviceAssetId }})
  }

  /* istanbul ignore next */
  const moveBackOneStep = (): void => {
    setIsDeviceDetailsEnabled(true)
    setDeviceIdAfterUpdate('')
  }
  const addDeviceConfigurations = (): void => {
    const indicatorPostData = {
      assetTypeId: assetType?.value,
      assetKpiConfigs: indicators
    }
    /* istanbul ignore next */
    props.addDeviceIndicator(indicatorPostData, deviceId)
    const parameterPostData = {
      assetTypeId: assetType?.value,
      assetParamConfigs: parameters
    }

    /* istanbul ignore next */
    props.addDeviceParameter(parameterPostData, deviceId)
  }
  /* istanbul ignore next */
  const deviceIndicatorSubmitWithFailure = (): JSX.Element => {
    if (props.deviceIndicatorState.httpStatus === httpStatus.CREATED_HTTP_STATUS && props.deviceParameterState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.SuccessfullyUpdated} LabelPositive={AddDeviceStrings.okay}
          onClickPositive={() => { setShowCreatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowCreatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddDeviceStrings.DeviceHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.deviceIndicatorState.isLoading || props.deviceParameterState.isLoading) {
      return (
        <Modal title={AddDeviceStrings.UpdatingDevice}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.deviceIndicatorState.httpStatus === httpStatus.BAD_REQUEST || props.deviceParameterState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.deviceIndicatorState.error ?? props.deviceParameterState.error} </p>
        </Modal>
      );
    } else if (props.deviceIndicatorState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS || props.deviceParameterState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }}
          onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddDeviceStrings.UpdateDeviceError} </p>
        </Modal>
      )
    }
  }
  const handleUpdateDevice = (): void => {
    /* istanbul ignore next */
    if (deviceIdAfterUpdate === '') {
      setIsDeviceCreateInProgress(true)
      updateDevice()
    } else setIsDeviceDetailsEnabled(false)
    const isCustomDevice = assetModel.label === 'Asset Model Not Applicable'
    window.sessionStorage.setItem('isCustomDevice', isCustomDevice ? 'true' : 'false')
  }

  const updateDevice = (): void => {
    toast.dismiss()
    const locationArray = location.split(',')
    const putData = {
      type: 'device',
      id: deviceIdParam,
      name: deviceName,
      serial_number: serialNumber !== '' ? serialNumber : null,
      application_type: applicationType,
      slave_id: slaveAddress,
      asset_type_id: assetType?.value,
      asset_model_id: assetModel?.value,
      asset_category_id: categoryTypeId,
      /* istanbul ignore next */
      latitude: locationArray?.length === 2 ? parseFloat(locationArray[0]) : '',
      /* istanbul ignore next */
      longitude: locationArray?.length === 2 ? parseFloat(locationArray[1]) : '',
      parent_asset_id: deviceAssetId,
      site_id: parentSiteId,
      port: isTcpProtocol ? portNumber : ''
    }
    props?.updateDevice(putData)
  }

  /* istanbul ignore next */
  const handleUpdateDeviceWithFailure = (): JSX.Element | null => {
    if (props?.updateDeviceState?.isLoading === false && props?.updateDeviceState?.data?.asset_id !== undefined && props?.updateDeviceState?.error === undefined) {
      CustomToast({
        type: 'success',
        heading: AddDeviceStrings.SuccessfullyUpdated,
        message: AddDeviceStrings.DeviceHasBeenUpdated
      })
      setIsDeviceCreateInProgress(false)
      return null
    } else if (props?.updateDeviceState?.isLoading && props?.updateDeviceState?.data === undefined && props?.updateDeviceState?.error === undefined) {
      return (
        <div className='CircularprogressAmi'>
          <CircularProgress />
        </div>
      )
    } else if (props?.updateDeviceState?.isLoading === false && props?.updateDeviceState?.data === undefined && props?.updateDeviceState?.error !== undefined) {
      CustomToast({
        type: 'error',
        heading: AddDeviceStrings.UpdateDeviceError,
        message: props?.updateDeviceState?.error
      })
      setIsDeviceCreateInProgress(false)
      return null
    }

    return null
  }

  /* istanbul ignore next */
  const handleImageUploadWithFailure = (): JSX.Element | null => {
    if (props?.imageUploadState.isLoading === true && props?.imageUploadState?.error === undefined && props?.imageUploadState?.data === undefined) {
      return (
        <Modal title={AddDeviceStrings.UploadingImage}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (props?.imageUploadState.isLoading === false && props?.imageUploadState?.error !== undefined && props?.imageUploadState?.data === undefined) {
      CustomToast({
        type: 'error',
        heading: AddDeviceStrings.UpdateDeviceError,
        message: props?.imageUploadState?.error
      })
      return null
    }
    return null
  }

  const handleFetchCategoryWithFailure = (): JSX.Element | null => {
    if (props?.assetCategories.isLoading === true && props?.assetCategories?.loadingError === null) {
      return (
        <div className='CircularprogressAmi'>
          <CircularProgress />
        </div>
      )
    } else if (props?.assetCategories.isLoading === false && props?.assetCategories?.loadingError !== '') {
      CustomToast({
        type: 'error',
        heading: AddDeviceStrings.Error,
        message: AddDeviceStrings.FetchAssetTypeError
      })

      return null
    }

    return null
  }

  const isDeviceNameNotValid = (): boolean => {
    return (
      !isValidDeviceData(deviceName) || deviceName?.length > MAX_LENGTH
    )
  }
  const isSerialNumberNotValid = (): boolean => {
    return (
      (serialNumber !== '' && (!isValidDeviceData(serialNumber) || serialNumber?.length > MAX_LENGTH)) || false
    )
  }
  const isapplicationTypeNotValid = (): boolean => {
    return (
      (applicationType !== '' && (!isValidDeviceData(applicationType) || applicationType?.length > MAX_LENGTH)) || false
    )
  }
  const isLocationNotValid = (): boolean => {
    return (
      (location !== '' && (!isValidLatLong(location) || location?.length === 0)) || false
    )
  }
  const isSlaveAddressNotValid = (): boolean => {
    return (
      !isValidSlaveAddress(slaveAddress) ||
      slaveAddress?.length === 0
    )
  }
  const isPortNumberNotValid = (): boolean => {
    const port = parseInt(portNumber, 10)
    return !(port > 0 && port <= 65535 && isValidDevicePort(portNumber) && portNumber.length <= 5)
  }

  const shouldDisableNextButton = (): boolean => {
    return (
      isDeviceNameNotValid() ||
      isSerialNumberNotValid() ||
      isapplicationTypeNotValid() ||
      isLocationNotValid() ||
      isSlaveAddressNotValid() ||
      (isTcpProtocol ? isPortNumberNotValid() : false)
    )
  }
  const shouldDisableAddButton = (): boolean => {
    return (
      isStdError || isCustomError || isModbusError
    )
  }

  if (props?.imageUploadState?.isLoading || props?.assetCategories?.isLoading || props?.updateDeviceState?.isLoading) {
    <div className='CircularprogressAmi'>
      <CircularProgress />
    </div>
  }
  return (
    <div>
      <div role="presentation" data-testid="breadcrumbs" onClick={handleBreadCrumbsClick} className="AmiHeading">
        <ArrowBackIos className="assetmgmtli" data-testid="breadcrumb-arrow-back" aria-label="navArrow" sx={{ marginTop: '10px' }}
          onClick={() => { navigate(-1) }}
        />
        <Breadcrumbs aria-label='breadcrumb' sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link aria-label='navBreadcrumb1' className='assetmgmtli' data-testid="bc-link-1" underline='none' color='inherit' onClick={() => { navigate('/thermal-dashboard') }} >
            {DashboardStrings.HOME}
          </Link>
          <Link aria-label='navBreadcrumb2' className='assetmgmtli' data-testid="bc-link-2" underline='none' color='inherit' onClick={() => { navigate('/site-list') }} >
            {DashboardStrings.SiteManagement}
          </Link>
          <Link aria-label='navBreadcrumb3' className='assetmgmtli' data-testid="bc-link-3" underline='none' color='inherit'
            onClick={() => { navigate(`/thermal-asset-list/${parentSiteId}`) }} >
            {DashboardStrings.AssetManagement}
          </Link>
          <Link aria-label="navBreadcrumb4" className='assetmgmtli' data-testid="bc-link-4" underline="none" color="inherit"
            onClick={() => { navigate(`/gateway-list/${deviceAssetId}`, { state: { parentSiteId } }) }} >
            {DashboardStrings.GatewayManagement}
          </Link>
          <Link aria-label="navBreadcrumb5" className='assetmgmtli' data-testid="bc-link-5" underline="none" color="inherit"
            onClick={() => {
              navigate(`/device-list/${parentAssetId}`, { state: { parentSiteId, deviceAssetId }})
            }}
          >
            {DashboardStrings.DeviceManagement}
          </Link>
          <Typography color="inherit" sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}>{DashboardStrings.EditDevice}</Typography>
        </Breadcrumbs>
      </div>
      <div className='ArrowDeviceAdd'>
        <div>
          <span
            style={{
              fontSize: '24px',
              fontWeight: 900,
              fontStyle: 'normal',
              lineHeight: '32px',
            }}
            data-testid='deviceHistoryDetails'
            className='deviceMgtDevicelist'
          >
            {AddDeviceStrings.EditDevice}
          </span>
        </div>
      </div>
      <div>
        {(isDeviceDetailsEnabled) ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '100px' }}>
            <img src={SelectDeviceType} />
          </div>
        )
          : (
            <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '100px' }}>
              <img src={AddParameters} />
            </div>
          )}
      </div>
      <div>
        {(isDeviceDetailsEnabled)
          ? (
            <DeviceInformation
              assetModel={assetModel}
              setAssetModel={setAssetModel}
              assetType={assetType}
              setAssetType={setAssetType}
              deviceType={props?.deviceType.deviceType}
              deviceName={deviceName}
              setDeviceName={setDeviceName}
              deviceNameErrorInit={deviceNameErrorInit}
              setDeviceNameErrorInit={setDeviceNameErrorInit}
              serialNumber={serialNumber}
              setSerialNumber={setSerialNumber}
              serialNumberErrorInit={serialNumberErrorInit}
              setGateway={setGateway}
              setSerialNumberErrorInit={setSerialNumberErrorInit}
              applicationType={applicationType}
              setApplicationType={setApplicationType}
              applicationTypeErrorInit={applicationTypeErrorInit}
              setApplicationTypeErrorInit={setApplicationTypeErrorInit}
              location={location}
              setLocation={setLocation}
              locationErrorInit={locationErrorInit}
              setLocationErrorInit={setLocationErrorInit}
              slaveAddress={slaveAddress}
              setSlaveAddress={setSlaveAddress}
              slaveAddressErrorInit={slaveAddressErrorInit}
              setSlaveAddressErrorInit={setSlaveAddressErrorInit}
              previewImage={previewImage}
              setPreviewImage={setPreviewImage}
              deviceImage={deviceImage}
              setDeviceImage={setDeviceImage}
              deviceId={deviceId}
              siteId={parentSiteId}
              portNumber={portNumber}
              setPortNumber={setPortNumber}
              portNumberErrorInit={portNumberErrorInit}
              setPortNumberErrorInit={setPortNumberErrorInit}
              isTcpProtocol={isTcpProtocol}
            />
          )
          : (
            <EditDeviceParameters assetId={deviceId} assetTypeId={assetType?.value ?? ''}
              setIsStdError={setIsStdError} setIsCustomError={setIsCustomError} setIsModbusError={setIsModbusError}
              setIndicators={setIndicators} setParameters={setParameters} indicators={indicators} parameters={parameters}
            />
          )}
      </div>
      <div
        style={{
          height: '80px',
          backgroundColor: '#272727',
          margin: '50px 0 10px 0',
          borderRadius: 10,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 1em'
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          {(isDeviceDetailsEnabled)
            ? (
              <>
                <Button
                  className='AddDeviceCancelButton'
                  data-testid="cancel-btn-click"
                  onClick={() => {
                    handeleCancelClick()
                  }}
                >
                  {AddDeviceStrings.Cancel}
                </Button>
                <Button
                  dataTestId="next-btn-click"
                  className={`${shouldDisableNextButton() ? 'btn-disabled' : ''}`}
                  onClick={() => { handleUpdateDevice() }}
                  disabled={shouldDisableNextButton()}
                >
                  {AddDeviceStrings.Next}
                </Button>
              </>
            )
            : (
              <>
                <Button
                  dataTestId='back-btn'
                  className='AddDeviceCancelButton'
                  onClick={moveBackOneStep}
                >
                  {AddDeviceStrings.Back}
                </Button>
                <Button
                  className={`${shouldDisableAddButton() ? 'btn-disabled' : ''}`} dataTestId="add-device-btn"
                  onClick={() => { setShowConfirmation(true) }} disabled={shouldDisableAddButton()}
                >
                  {AddDeviceStrings.Update}
                </Button>
              </>
            )}
        </div>
      </div>
      {isDeviceCreateInProgress && handleUpdateDeviceWithFailure()}
      {showConfirmation &&
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.UpdatDevice} LabelNegative={AddDeviceStrings.Cancel} LabelPositive={AddDeviceStrings.Confirm} onClickPositive={() => {
          setShowConfirmation(false), setShowCreatePopup(true), addDeviceConfigurations()
        }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
          <p style={{ paddingTop: '1.2em' }}>De-selecting a parameter used in KPI creation will stop the KPI execution. {AddDeviceStrings.DeviceUpdateConfirmation}</p>
        </Modal>
      }
      {showCreatePopup && deviceIndicatorSubmitWithFailure()}
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchAssetCategories: () => void
  fetchDeviceType: (categoryTypeId: string) => void
  fetchDeviceModel: (deviceTypeId: string) => void
  fetchDeviceInfo: (deviceTypeId: string) => void
  updateDevice: (updateDevicePutRequest: UpdateDevicePutRequest) => void
  downloadImage: (assetId: string, assetTypeId: string, locale: string) => void
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void
  addDeviceIndicator: (addDeviceIndicatorRequest: any, assetId: string) => void
  addDeviceParameter: (addDeviceParamRequest: any, assetId: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) =>
    dispatch(getOperationPermissions(sub)),
  fetchAssetCategories: () => dispatch(fetchAssetCategories()),
  fetchDeviceType: (categoryTypeId: string) =>
    dispatch(fetchDeviceType(categoryTypeId)),
  fetchDeviceModel: (deviceTypeId: string) =>
    dispatch(fetchDeviceModel(deviceTypeId)),
  fetchDeviceInfo: (deviceTypeId: string) =>
    dispatch(fetchDeviceInfo(deviceTypeId)),
  updateDevice: (updateDevicePutRequest: UpdateDevicePutRequest) => dispatch(updateDevice(updateDevicePutRequest)),
  downloadImage: (assetId: string, assetTypeId: string, locale: string) =>
    dispatch(downloadImage(assetId, assetTypeId, locale)),
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest)),
  addDeviceIndicator: (addDeviceIndicatorRequest: any, assetId: string) => dispatch(addDeviceIndicator(addDeviceIndicatorRequest, assetId)),
  addDeviceParameter: (addDeviceParamRequest: any, assetId: string) => dispatch(addDeviceParameter(addDeviceParamRequest, assetId))
})

interface StateToProps {
  assetCategories: AssetCategoriesState
  deviceType: DeviceTypeState
  deviceModel: DeviceModelState,
  deviceInfo: DeviceInfoState,
  updateDeviceState: UpdateDeviceState,
  downloadImageState: DownloadImageState,
  imageUploadState: ImageUploadState,
  deviceIndicatorState: DeviceIndicatorState,
  deviceParameterState: DeviceParameterState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  assetCategories: state.assetCategories,
  deviceType: state.deviceType,
  deviceModel: state.deviceModel,
  deviceInfo: state.deviceInfoState,
  updateDeviceState: state.updateDeviceState,
  downloadImageState: state.downloadImageState,
  imageUploadState: state.imageUploadState,
  deviceIndicatorState: state.deviceIndicatorState,
  deviceParameterState: state.deviceParameterState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(EditDevice)
